<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder text-success text-gradient">
                    Bienvenido de nuevo
                  </h3>
                  <p class="mb-0">Ingresa tu correo y contraseña para iniciar sesión</p>
                </div>
                <div class="card-body">
                  <form role="form" class="text-start" @submit.prevent="login">
                    <label>Email</label>
                    <input
                        class="form-control"
                        v-model="email"
                      id="email"
                      type="email"
                      placeholder="Email"
                      name="email"
                    />
                    <label>Contraseña</label>
                    <input
                        class="form-control"
                        v-model="password"
                      id="password"
                      type="password"
                       placeholder="Contraseña"
                      name="password"
                    />
                    <div class="text-center">
                      <soft-button
                        class="my-4 mb-2"
                        type="sumit"
                        variant="gradient"
                        color="success"
                        full-width
                        >INGRESAR
                      </soft-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <img src="@/assets/img/retention.jpg" alt="" style="width: 100%">
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import {post} from "@/utils/httpRequest";
import {decrypt} from "@/utils/encrypt";

export default {
  name: "SignIn",
  components: {
    SoftButton,
  },
  data: () => ({
    email: '',
    password: ''
  }),

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    showError(message){
      this.$swal({
        html: message,
        icon: 'error',
        timer: 3000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    async login(){
      if(!(this.email.length > 2 && this.password.length > 2)){
        this.showError('El correo y la contraseña deben tener al menos 3 caracteres');
        return;
      }
      try {
        const {data} = await post('auth/login',{email: this.email, password: this.password}, false)
        if(data.statusCode === 200){
          const role = decrypt(data.role);
          if(['administrator','agent_ftd','agent_retention','supervisor_retention','supervisor_ftd'].includes(role)){
            localStorage.setItem('payment-admin-token', data.token)
            localStorage.setItem('payment-admin-type', data.role)
            localStorage.setItem('payment-admin-uuid', data.uid)
            await this.$router.push('/dashboard')
          }else{
            // Rol no autorizado para el panel admin (ej: clients/leads).
            localStorage.clear()
            this.showError('Tu usuario no tiene acceso a este panel.')
          }
        } else if(data.statusCode === 404){
          this.showError('Usuario no encontrado.')
        } else if(data.message){
          // 403 IP no autorizada u otros casos con mensaje explícito del back.
          this.showError(data.message)
        } else {
          this.showError('Correo o contraseña incorrectos.')
        }
      } catch (e) {
        // 429 (rate limit) u otros errores HTTP llegan como excepción de axios.
        const status = e?.response?.status;
        const msg = e?.response?.data?.message;
        if(status === 429){
          this.showError(msg || 'Demasiados intentos. Esperá un momento e intentá de nuevo.')
        } else {
          this.showError(msg || 'No se pudo iniciar sesión. Intentá de nuevo.')
        }
      }
    }
  },
};
</script>
